export default "__VITE_ASSET__c8Yb8K4T__"